import { useState, useEffect } from 'react';
import { SellerSignupPage } from './auth/SellerSignupPage';
import { DesktopSellerSignupPage } from './desktop/DesktopSellerSignupPage';

export function ResponsiveSellerSignupPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerSignupPage /> : <DesktopSellerSignupPage />;
}